import { createFileRoute } from '@tanstack/react-router';

import { RetryQuizPage } from '@/pages/retry-quiz';

type RetryQuizSearchParams = {
  courseId: string;
  contentId: string;
  quizId: string;
};

export const Route = createFileRoute('/_user/courses/retry-quiz')({
  validateSearch: (search: Record<string, string>): RetryQuizSearchParams => {
    const courseId = search.courseId ?? '';
    const contentId = search.contentId ?? '';
    const quizId = search.quizId ?? '';

    return {
      courseId,
      contentId,
      quizId,
    };
  },
  component: RetryQuizPage,
});

